
import urls from '../Urls'
import axios from 'axios'

export const CHILD_API_ENDPOINTS = {
  VALIDATE: 'validate'
}

function getAddressValidationApiEndPoint () {
  return urls.addressApiController() + '/' + CHILD_API_ENDPOINTS.VALIDATE
}

function validateAddress (data) {
  return axios.post(getAddressValidationApiEndPoint(), data)
}

export default {
  validateAddress: validateAddress
}
